import { createSlice } from '@reduxjs/toolkit';
import {address} from "../utils";

const initialState = {
    totalVotes: "0",
    userBalance: "0",
    userDelegate: address(0),
    userVotes: "0"
};

const govTokenSlice = createSlice({
    name: 'govToken',
    initialState,
    reducers: {
        setTotalVotes(state, action) {
            state.totalVotes = action.payload;
        },
        setUserBalance(state, action) {
            state.userBalance = action.payload;
        },
        setUserDelegate(state, action) {
            state.userDelegate = action.payload;
        },
        setUserVotes(state, action) {
            state.userVotes = action.payload;
        },
    },
});

export const {
    setTotalVotes,
    setUserBalance,
    setUserDelegate,
    setUserVotes
} = govTokenSlice.actions;
export default govTokenSlice.reducer;

function fetchGovTokenData({account, xRoobee}) {
    return dispatch => {
        if (xRoobee) {
            xRoobee.totalSupply().then(result => {
                dispatch(setTotalVotes(result.toString()));
            });
        }
        if (xRoobee && account) {
            xRoobee.balanceOf(account).then(result => {
                dispatch(setUserBalance(result.toString()));
            });
            xRoobee.delegates(account).then(result => {
                dispatch(setUserDelegate(result.toString()));
            });
            xRoobee.getCurrentVotes(account).then(result => {
                dispatch(setUserVotes(result.toString()));
            });
        }
    };
}

export { fetchGovTokenData };
